import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _2fcc5d18 = () => interopDefault(import('../themes/ecom/pages/index.vue' /* webpackChunkName: "themes/ecom/pages/index" */))
const _442ba404 = () => interopDefault(import('../themes/ecom/pages/404.vue' /* webpackChunkName: "themes/ecom/pages/404" */))
const _54c682d4 = () => interopDefault(import('../themes/ecom/pages/about/index.vue' /* webpackChunkName: "themes/ecom/pages/about/index" */))
const _249409b6 = () => interopDefault(import('../themes/ecom/pages/account/index.vue' /* webpackChunkName: "themes/ecom/pages/account/index" */))
const _3cd28bac = () => interopDefault(import('../themes/ecom/pages/articles/index.vue' /* webpackChunkName: "themes/ecom/pages/articles/index" */))
const _5775985c = () => interopDefault(import('../themes/ecom/pages/auth.vue' /* webpackChunkName: "themes/ecom/pages/auth" */))
const _0ea44379 = () => interopDefault(import('../themes/ecom/pages/brands/index.vue' /* webpackChunkName: "themes/ecom/pages/brands/index" */))
const _da3c2fbe = () => interopDefault(import('../themes/ecom/pages/cabinet/index.vue' /* webpackChunkName: "themes/ecom/pages/cabinet/index" */))
const _1a0ee628 = () => interopDefault(import('../themes/ecom/pages/career.vue' /* webpackChunkName: "themes/ecom/pages/career" */))
const _2fd03c4d = () => interopDefault(import('../themes/ecom/pages/cart/index.vue' /* webpackChunkName: "themes/ecom/pages/cart/index" */))
const _94a32ebc = () => interopDefault(import('../themes/ecom/pages/catalog/index.vue' /* webpackChunkName: "themes/ecom/pages/catalog/index" */))
const _44763c2b = () => interopDefault(import('../themes/ecom/pages/compare.vue' /* webpackChunkName: "themes/ecom/pages/compare" */))
const _ef5bbc42 = () => interopDefault(import('../themes/ecom/pages/confirmation.vue' /* webpackChunkName: "themes/ecom/pages/confirmation" */))
const _58d124c0 = () => interopDefault(import('../themes/ecom/pages/contacts/index.vue' /* webpackChunkName: "themes/ecom/pages/contacts/index" */))
const _7e345423 = () => interopDefault(import('../themes/ecom/pages/credit.vue' /* webpackChunkName: "themes/ecom/pages/credit" */))
const _c632ad2c = () => interopDefault(import('../themes/ecom/pages/dayoffer.vue' /* webpackChunkName: "themes/ecom/pages/dayoffer" */))
const _6ee2531e = () => interopDefault(import('../themes/ecom/pages/delivery.vue' /* webpackChunkName: "themes/ecom/pages/delivery" */))
const _66fe3deb = () => interopDefault(import('../themes/ecom/pages/discount.vue' /* webpackChunkName: "themes/ecom/pages/discount" */))
const _4fb37b42 = () => interopDefault(import('../themes/ecom/pages/faq/index.vue' /* webpackChunkName: "themes/ecom/pages/faq/index" */))
const _50194d1d = () => interopDefault(import('../themes/ecom/pages/favorites.vue' /* webpackChunkName: "themes/ecom/pages/favorites" */))
const _102af4d4 = () => interopDefault(import('../themes/ecom/pages/feedbacks.vue' /* webpackChunkName: "themes/ecom/pages/feedbacks" */))
const _0bd6dfc0 = () => interopDefault(import('../themes/ecom/pages/insurance.vue' /* webpackChunkName: "themes/ecom/pages/insurance" */))
const _48971d94 = () => interopDefault(import('../themes/ecom/pages/order.vue' /* webpackChunkName: "themes/ecom/pages/order" */))
const _50eec055 = () => interopDefault(import('../themes/ecom/pages/partners.vue' /* webpackChunkName: "themes/ecom/pages/partners" */))
const _433341f8 = () => interopDefault(import('../themes/ecom/pages/product/index.vue' /* webpackChunkName: "themes/ecom/pages/product/index" */))
const _210f3f9b = () => interopDefault(import('../themes/ecom/pages/product_list/index.vue' /* webpackChunkName: "themes/ecom/pages/product_list/index" */))
const _5b6e482d = () => interopDefault(import('../themes/ecom/pages/products-feed.vue' /* webpackChunkName: "themes/ecom/pages/products-feed" */))
const _46f6b913 = () => interopDefault(import('../themes/ecom/pages/questions.vue' /* webpackChunkName: "themes/ecom/pages/questions" */))
const _3cd63992 = () => interopDefault(import('../themes/ecom/pages/regulamente.vue' /* webpackChunkName: "themes/ecom/pages/regulamente" */))
const _2ed25902 = () => interopDefault(import('../themes/ecom/pages/review.vue' /* webpackChunkName: "themes/ecom/pages/review" */))
const _757e1f52 = () => interopDefault(import('../themes/ecom/pages/search.vue' /* webpackChunkName: "themes/ecom/pages/search" */))
const _2bcd440a = () => interopDefault(import('../themes/ecom/pages/service.vue' /* webpackChunkName: "themes/ecom/pages/service" */))
const _730dca18 = () => interopDefault(import('../themes/ecom/pages/special-offers/index.vue' /* webpackChunkName: "themes/ecom/pages/special-offers/index" */))
const _4c6bc966 = () => interopDefault(import('../themes/ecom/pages/terms.vue' /* webpackChunkName: "themes/ecom/pages/terms" */))
const _3aadcbfe = () => interopDefault(import('../themes/ecom/pages/video-obzori/index.vue' /* webpackChunkName: "themes/ecom/pages/video-obzori/index" */))
const _53947178 = () => interopDefault(import('../themes/ecom/pages/account/history.vue' /* webpackChunkName: "themes/ecom/pages/account/history" */))
const _f1f5be18 = () => interopDefault(import('../themes/ecom/pages/cabinet/activate.vue' /* webpackChunkName: "themes/ecom/pages/cabinet/activate" */))
const _64d7e7b4 = () => interopDefault(import('../themes/ecom/pages/cabinet/orders.vue' /* webpackChunkName: "themes/ecom/pages/cabinet/orders" */))
const _6f513165 = () => interopDefault(import('../themes/ecom/pages/cabinet/profile-security.vue' /* webpackChunkName: "themes/ecom/pages/cabinet/profile-security" */))
const _3ba4561e = () => interopDefault(import('../themes/ecom/pages/cabinet/reset.vue' /* webpackChunkName: "themes/ecom/pages/cabinet/reset" */))
const _869ecbf8 = () => interopDefault(import('../themes/ecom/pages/cart/casaCart/index.vue' /* webpackChunkName: "themes/ecom/pages/cart/casaCart/index" */))
const _97b5ff68 = () => interopDefault(import('../themes/ecom/pages/cart/farmacieCart/index.vue' /* webpackChunkName: "themes/ecom/pages/cart/farmacieCart/index" */))
const _1ffa663e = () => interopDefault(import('../themes/ecom/pages/cart/success.vue' /* webpackChunkName: "themes/ecom/pages/cart/success" */))
const _b3141f6e = () => interopDefault(import('../themes/ecom/pages/faq/types.js' /* webpackChunkName: "themes/ecom/pages/faq/types" */))
const _30e032ae = () => interopDefault(import('../themes/ecom/pages/video-obzori/view.vue' /* webpackChunkName: "themes/ecom/pages/video-obzori/view" */))
const _18f4aa61 = () => interopDefault(import('../themes/ecom/pages/about/components/ContentImageBlock/index.vue' /* webpackChunkName: "themes/ecom/pages/about/components/ContentImageBlock/index" */))
const _2bc579e4 = () => interopDefault(import('../themes/ecom/pages/about/components/LogoTypes/index.vue' /* webpackChunkName: "themes/ecom/pages/about/components/LogoTypes/index" */))
const _51c0dff8 = () => interopDefault(import('../themes/ecom/pages/cart/casaCart/types.js' /* webpackChunkName: "themes/ecom/pages/cart/casaCart/types" */))
const _34de3d24 = () => interopDefault(import('../themes/ecom/pages/contacts/components/Form/index.vue' /* webpackChunkName: "themes/ecom/pages/contacts/components/Form/index" */))
const _b375c662 = () => interopDefault(import('../themes/ecom/pages/faq/components/AccordionsBlock/index.vue' /* webpackChunkName: "themes/ecom/pages/faq/components/AccordionsBlock/index" */))
const _4bccfff2 = () => interopDefault(import('../themes/ecom/pages/about/components/ContentImageBlock/types.js' /* webpackChunkName: "themes/ecom/pages/about/components/ContentImageBlock/types" */))
const _a18c10dc = () => interopDefault(import('../themes/ecom/pages/cart/casaCart/components/CartProducts/index.vue' /* webpackChunkName: "themes/ecom/pages/cart/casaCart/components/CartProducts/index" */))
const _01e42e82 = () => interopDefault(import('../themes/ecom/pages/cart/casaCart/components/Credits/index.vue' /* webpackChunkName: "themes/ecom/pages/cart/casaCart/components/Credits/index" */))
const _89f5629c = () => interopDefault(import('../themes/ecom/pages/cart/casaCart/components/Form/index.vue' /* webpackChunkName: "themes/ecom/pages/cart/casaCart/components/Form/index" */))
const _0fd7ec35 = () => interopDefault(import('../themes/ecom/pages/cart/casaCart/components/CartProducts/PlankCard/index.vue' /* webpackChunkName: "themes/ecom/pages/cart/casaCart/components/CartProducts/PlankCard/index" */))
const _b323e286 = () => interopDefault(import('../themes/ecom/pages/cart/casaCart/components/Form/MyActionBtn/index.vue' /* webpackChunkName: "themes/ecom/pages/cart/casaCart/components/Form/MyActionBtn/index" */))
const _01b29a48 = () => interopDefault(import('../themes/ecom/pages/cart/casaCart/components/Form/MyActionTabBtn/index.vue' /* webpackChunkName: "themes/ecom/pages/cart/casaCart/components/Form/MyActionTabBtn/index" */))
const _42ff5160 = () => interopDefault(import('../themes/ecom/pages/cart/casaCart/components/Form/MyCheckboxBtn/index.vue' /* webpackChunkName: "themes/ecom/pages/cart/casaCart/components/Form/MyCheckboxBtn/index" */))
const _35e04b41 = () => interopDefault(import('../themes/ecom/pages/cart/casaCart/components/Form/MyInput/index.vue' /* webpackChunkName: "themes/ecom/pages/cart/casaCart/components/Form/MyInput/index" */))
const _4871288a = () => interopDefault(import('../themes/ecom/pages/cart/casaCart/components/Form/MySelect/index.vue' /* webpackChunkName: "themes/ecom/pages/cart/casaCart/components/Form/MySelect/index" */))
const _43dfa541 = () => interopDefault(import('../themes/ecom/pages/cart/casaCart/components/Form/MySwitchToggler/index.vue' /* webpackChunkName: "themes/ecom/pages/cart/casaCart/components/Form/MySwitchToggler/index" */))
const _b70ec10e = () => interopDefault(import('../themes/ecom/pages/cart/casaCart/components/Form/MyTextarea/index.vue' /* webpackChunkName: "themes/ecom/pages/cart/casaCart/components/Form/MyTextarea/index" */))
const _07f4202b = () => interopDefault(import('../themes/ecom/pages/cart/casaCart/components/Form/MyActionBtn/types.js' /* webpackChunkName: "themes/ecom/pages/cart/casaCart/components/Form/MyActionBtn/types" */))
const _491e3f88 = () => interopDefault(import('../themes/ecom/pages/articles/_url.vue' /* webpackChunkName: "themes/ecom/pages/articles/_url" */))
const _0ceda231 = () => interopDefault(import('../themes/ecom/pages/brands/_slug.vue' /* webpackChunkName: "themes/ecom/pages/brands/_slug" */))
const _55ae1326 = () => interopDefault(import('../themes/ecom/pages/l/_slug.vue' /* webpackChunkName: "themes/ecom/pages/l/_slug" */))
const _c9b6480c = () => interopDefault(import('../themes/ecom/pages/product/_product.vue' /* webpackChunkName: "themes/ecom/pages/product/_product" */))
const _0f994850 = () => interopDefault(import('../themes/ecom/pages/promo/_slug.vue' /* webpackChunkName: "themes/ecom/pages/promo/_slug" */))
const _6ca30c4c = () => interopDefault(import('../themes/ecom/pages/special-offers/_url.vue' /* webpackChunkName: "themes/ecom/pages/special-offers/_url" */))
const _0d852d25 = () => interopDefault(import('../themes/ecom/pages/_.vue' /* webpackChunkName: "themes/ecom/pages/_" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'active',
  linkExactActiveClass: 'active',
  scrollBehavior,

  routes: [{
    path: "/en",
    component: _2fcc5d18,
    pathToRegexpOptions: {"strict":true},
    name: "index___en"
  }, {
    path: "/ro",
    component: _2fcc5d18,
    pathToRegexpOptions: {"strict":true},
    name: "index___ro"
  }, {
    path: "/ru",
    component: _2fcc5d18,
    pathToRegexpOptions: {"strict":true},
    name: "index___ru"
  }, {
    path: "/uk",
    component: _2fcc5d18,
    pathToRegexpOptions: {"strict":true},
    name: "index___uk"
  }, {
    path: "/en/404",
    component: _442ba404,
    pathToRegexpOptions: {"strict":true},
    name: "404___en"
  }, {
    path: "/en/about",
    component: _54c682d4,
    pathToRegexpOptions: {"strict":true},
    name: "about___en"
  }, {
    path: "/en/account",
    component: _249409b6,
    pathToRegexpOptions: {"strict":true},
    name: "account___en"
  }, {
    path: "/en/articles",
    component: _3cd28bac,
    pathToRegexpOptions: {"strict":true},
    name: "articles___en"
  }, {
    path: "/en/auth",
    component: _5775985c,
    pathToRegexpOptions: {"strict":true},
    name: "auth___en"
  }, {
    path: "/en/brands",
    component: _0ea44379,
    pathToRegexpOptions: {"strict":true},
    name: "brands___en"
  }, {
    path: "/en/cabinet",
    component: _da3c2fbe,
    pathToRegexpOptions: {"strict":true},
    name: "cabinet___en"
  }, {
    path: "/en/career",
    component: _1a0ee628,
    pathToRegexpOptions: {"strict":true},
    name: "career___en"
  }, {
    path: "/en/cart",
    component: _2fd03c4d,
    pathToRegexpOptions: {"strict":true},
    name: "cart___en"
  }, {
    path: "/en/catalog",
    component: _94a32ebc,
    pathToRegexpOptions: {"strict":true},
    name: "catalog___en"
  }, {
    path: "/en/compare",
    component: _44763c2b,
    pathToRegexpOptions: {"strict":true},
    name: "compare___en"
  }, {
    path: "/en/confirmation",
    component: _ef5bbc42,
    pathToRegexpOptions: {"strict":true},
    name: "confirmation___en"
  }, {
    path: "/en/contacts",
    component: _58d124c0,
    pathToRegexpOptions: {"strict":true},
    name: "contacts___en"
  }, {
    path: "/en/credit",
    component: _7e345423,
    pathToRegexpOptions: {"strict":true},
    name: "credit___en"
  }, {
    path: "/en/dayoffer",
    component: _c632ad2c,
    pathToRegexpOptions: {"strict":true},
    name: "dayoffer___en"
  }, {
    path: "/en/delivery",
    component: _6ee2531e,
    pathToRegexpOptions: {"strict":true},
    name: "delivery___en"
  }, {
    path: "/en/discount",
    component: _66fe3deb,
    pathToRegexpOptions: {"strict":true},
    name: "discount___en"
  }, {
    path: "/en/faq",
    component: _4fb37b42,
    pathToRegexpOptions: {"strict":true},
    name: "faq___en"
  }, {
    path: "/en/favorites",
    component: _50194d1d,
    pathToRegexpOptions: {"strict":true},
    name: "favorites___en"
  }, {
    path: "/en/feedbacks",
    component: _102af4d4,
    pathToRegexpOptions: {"strict":true},
    name: "feedbacks___en"
  }, {
    path: "/en/insurance",
    component: _0bd6dfc0,
    pathToRegexpOptions: {"strict":true},
    name: "insurance___en"
  }, {
    path: "/en/order",
    component: _48971d94,
    pathToRegexpOptions: {"strict":true},
    name: "order___en"
  }, {
    path: "/en/partners",
    component: _50eec055,
    pathToRegexpOptions: {"strict":true},
    name: "partners___en"
  }, {
    path: "/en/product",
    component: _433341f8,
    pathToRegexpOptions: {"strict":true},
    name: "product___en"
  }, {
    path: "/en/product_list",
    component: _210f3f9b,
    pathToRegexpOptions: {"strict":true},
    name: "product_list___en"
  }, {
    path: "/en/products-feed",
    component: _5b6e482d,
    pathToRegexpOptions: {"strict":true},
    name: "products-feed___en"
  }, {
    path: "/en/questions",
    component: _46f6b913,
    pathToRegexpOptions: {"strict":true},
    name: "questions___en"
  }, {
    path: "/en/regulamente",
    component: _3cd63992,
    pathToRegexpOptions: {"strict":true},
    name: "regulamente___en"
  }, {
    path: "/en/review",
    component: _2ed25902,
    pathToRegexpOptions: {"strict":true},
    name: "review___en"
  }, {
    path: "/en/search",
    component: _757e1f52,
    pathToRegexpOptions: {"strict":true},
    name: "search___en"
  }, {
    path: "/en/service",
    component: _2bcd440a,
    pathToRegexpOptions: {"strict":true},
    name: "service___en"
  }, {
    path: "/en/special-offers",
    component: _730dca18,
    pathToRegexpOptions: {"strict":true},
    name: "special-offers___en"
  }, {
    path: "/en/terms",
    component: _4c6bc966,
    pathToRegexpOptions: {"strict":true},
    name: "terms___en"
  }, {
    path: "/en/video-obzori",
    component: _3aadcbfe,
    pathToRegexpOptions: {"strict":true},
    name: "video-obzori___en"
  }, {
    path: "/ro/404",
    component: _442ba404,
    pathToRegexpOptions: {"strict":true},
    name: "404___ro"
  }, {
    path: "/ro/about",
    component: _54c682d4,
    pathToRegexpOptions: {"strict":true},
    name: "about___ro"
  }, {
    path: "/ro/account",
    component: _249409b6,
    pathToRegexpOptions: {"strict":true},
    name: "account___ro"
  }, {
    path: "/ro/articles",
    component: _3cd28bac,
    pathToRegexpOptions: {"strict":true},
    name: "articles___ro"
  }, {
    path: "/ro/auth",
    component: _5775985c,
    pathToRegexpOptions: {"strict":true},
    name: "auth___ro"
  }, {
    path: "/ro/brands",
    component: _0ea44379,
    pathToRegexpOptions: {"strict":true},
    name: "brands___ro"
  }, {
    path: "/ro/cabinet",
    component: _da3c2fbe,
    pathToRegexpOptions: {"strict":true},
    name: "cabinet___ro"
  }, {
    path: "/ro/career",
    component: _1a0ee628,
    pathToRegexpOptions: {"strict":true},
    name: "career___ro"
  }, {
    path: "/ro/cart",
    component: _2fd03c4d,
    pathToRegexpOptions: {"strict":true},
    name: "cart___ro"
  }, {
    path: "/ro/catalog",
    component: _94a32ebc,
    pathToRegexpOptions: {"strict":true},
    name: "catalog___ro"
  }, {
    path: "/ro/compare",
    component: _44763c2b,
    pathToRegexpOptions: {"strict":true},
    name: "compare___ro"
  }, {
    path: "/ro/confirmation",
    component: _ef5bbc42,
    pathToRegexpOptions: {"strict":true},
    name: "confirmation___ro"
  }, {
    path: "/ro/contacts",
    component: _58d124c0,
    pathToRegexpOptions: {"strict":true},
    name: "contacts___ro"
  }, {
    path: "/ro/credit",
    component: _7e345423,
    pathToRegexpOptions: {"strict":true},
    name: "credit___ro"
  }, {
    path: "/ro/dayoffer",
    component: _c632ad2c,
    pathToRegexpOptions: {"strict":true},
    name: "dayoffer___ro"
  }, {
    path: "/ro/delivery",
    component: _6ee2531e,
    pathToRegexpOptions: {"strict":true},
    name: "delivery___ro"
  }, {
    path: "/ro/discount",
    component: _66fe3deb,
    pathToRegexpOptions: {"strict":true},
    name: "discount___ro"
  }, {
    path: "/ro/faq",
    component: _4fb37b42,
    pathToRegexpOptions: {"strict":true},
    name: "faq___ro"
  }, {
    path: "/ro/favorites",
    component: _50194d1d,
    pathToRegexpOptions: {"strict":true},
    name: "favorites___ro"
  }, {
    path: "/ro/feedbacks",
    component: _102af4d4,
    pathToRegexpOptions: {"strict":true},
    name: "feedbacks___ro"
  }, {
    path: "/ro/insurance",
    component: _0bd6dfc0,
    pathToRegexpOptions: {"strict":true},
    name: "insurance___ro"
  }, {
    path: "/ro/order",
    component: _48971d94,
    pathToRegexpOptions: {"strict":true},
    name: "order___ro"
  }, {
    path: "/ro/partners",
    component: _50eec055,
    pathToRegexpOptions: {"strict":true},
    name: "partners___ro"
  }, {
    path: "/ro/product",
    component: _433341f8,
    pathToRegexpOptions: {"strict":true},
    name: "product___ro"
  }, {
    path: "/ro/product_list",
    component: _210f3f9b,
    pathToRegexpOptions: {"strict":true},
    name: "product_list___ro"
  }, {
    path: "/ro/products-feed",
    component: _5b6e482d,
    pathToRegexpOptions: {"strict":true},
    name: "products-feed___ro"
  }, {
    path: "/ro/questions",
    component: _46f6b913,
    pathToRegexpOptions: {"strict":true},
    name: "questions___ro"
  }, {
    path: "/ro/regulamente",
    component: _3cd63992,
    pathToRegexpOptions: {"strict":true},
    name: "regulamente___ro"
  }, {
    path: "/ro/review",
    component: _2ed25902,
    pathToRegexpOptions: {"strict":true},
    name: "review___ro"
  }, {
    path: "/ro/search",
    component: _757e1f52,
    pathToRegexpOptions: {"strict":true},
    name: "search___ro"
  }, {
    path: "/ro/service",
    component: _2bcd440a,
    pathToRegexpOptions: {"strict":true},
    name: "service___ro"
  }, {
    path: "/ro/special-offers",
    component: _730dca18,
    pathToRegexpOptions: {"strict":true},
    name: "special-offers___ro"
  }, {
    path: "/ro/terms",
    component: _4c6bc966,
    pathToRegexpOptions: {"strict":true},
    name: "terms___ro"
  }, {
    path: "/ro/video-obzori",
    component: _3aadcbfe,
    pathToRegexpOptions: {"strict":true},
    name: "video-obzori___ro"
  }, {
    path: "/ru/404",
    component: _442ba404,
    pathToRegexpOptions: {"strict":true},
    name: "404___ru"
  }, {
    path: "/ru/about",
    component: _54c682d4,
    pathToRegexpOptions: {"strict":true},
    name: "about___ru"
  }, {
    path: "/ru/account",
    component: _249409b6,
    pathToRegexpOptions: {"strict":true},
    name: "account___ru"
  }, {
    path: "/ru/articles",
    component: _3cd28bac,
    pathToRegexpOptions: {"strict":true},
    name: "articles___ru"
  }, {
    path: "/ru/auth",
    component: _5775985c,
    pathToRegexpOptions: {"strict":true},
    name: "auth___ru"
  }, {
    path: "/ru/brands",
    component: _0ea44379,
    pathToRegexpOptions: {"strict":true},
    name: "brands___ru"
  }, {
    path: "/ru/cabinet",
    component: _da3c2fbe,
    pathToRegexpOptions: {"strict":true},
    name: "cabinet___ru"
  }, {
    path: "/ru/career",
    component: _1a0ee628,
    pathToRegexpOptions: {"strict":true},
    name: "career___ru"
  }, {
    path: "/ru/cart",
    component: _2fd03c4d,
    pathToRegexpOptions: {"strict":true},
    name: "cart___ru"
  }, {
    path: "/ru/catalog",
    component: _94a32ebc,
    pathToRegexpOptions: {"strict":true},
    name: "catalog___ru"
  }, {
    path: "/ru/compare",
    component: _44763c2b,
    pathToRegexpOptions: {"strict":true},
    name: "compare___ru"
  }, {
    path: "/ru/confirmation",
    component: _ef5bbc42,
    pathToRegexpOptions: {"strict":true},
    name: "confirmation___ru"
  }, {
    path: "/ru/contacts",
    component: _58d124c0,
    pathToRegexpOptions: {"strict":true},
    name: "contacts___ru"
  }, {
    path: "/ru/credit",
    component: _7e345423,
    pathToRegexpOptions: {"strict":true},
    name: "credit___ru"
  }, {
    path: "/ru/dayoffer",
    component: _c632ad2c,
    pathToRegexpOptions: {"strict":true},
    name: "dayoffer___ru"
  }, {
    path: "/ru/delivery",
    component: _6ee2531e,
    pathToRegexpOptions: {"strict":true},
    name: "delivery___ru"
  }, {
    path: "/ru/discount",
    component: _66fe3deb,
    pathToRegexpOptions: {"strict":true},
    name: "discount___ru"
  }, {
    path: "/ru/faq",
    component: _4fb37b42,
    pathToRegexpOptions: {"strict":true},
    name: "faq___ru"
  }, {
    path: "/ru/favorites",
    component: _50194d1d,
    pathToRegexpOptions: {"strict":true},
    name: "favorites___ru"
  }, {
    path: "/ru/feedbacks",
    component: _102af4d4,
    pathToRegexpOptions: {"strict":true},
    name: "feedbacks___ru"
  }, {
    path: "/ru/insurance",
    component: _0bd6dfc0,
    pathToRegexpOptions: {"strict":true},
    name: "insurance___ru"
  }, {
    path: "/ru/order",
    component: _48971d94,
    pathToRegexpOptions: {"strict":true},
    name: "order___ru"
  }, {
    path: "/ru/partners",
    component: _50eec055,
    pathToRegexpOptions: {"strict":true},
    name: "partners___ru"
  }, {
    path: "/ru/product",
    component: _433341f8,
    pathToRegexpOptions: {"strict":true},
    name: "product___ru"
  }, {
    path: "/ru/product_list",
    component: _210f3f9b,
    pathToRegexpOptions: {"strict":true},
    name: "product_list___ru"
  }, {
    path: "/ru/products-feed",
    component: _5b6e482d,
    pathToRegexpOptions: {"strict":true},
    name: "products-feed___ru"
  }, {
    path: "/ru/questions",
    component: _46f6b913,
    pathToRegexpOptions: {"strict":true},
    name: "questions___ru"
  }, {
    path: "/ru/regulamente",
    component: _3cd63992,
    pathToRegexpOptions: {"strict":true},
    name: "regulamente___ru"
  }, {
    path: "/ru/review",
    component: _2ed25902,
    pathToRegexpOptions: {"strict":true},
    name: "review___ru"
  }, {
    path: "/ru/search",
    component: _757e1f52,
    pathToRegexpOptions: {"strict":true},
    name: "search___ru"
  }, {
    path: "/ru/service",
    component: _2bcd440a,
    pathToRegexpOptions: {"strict":true},
    name: "service___ru"
  }, {
    path: "/ru/special-offers",
    component: _730dca18,
    pathToRegexpOptions: {"strict":true},
    name: "special-offers___ru"
  }, {
    path: "/ru/terms",
    component: _4c6bc966,
    pathToRegexpOptions: {"strict":true},
    name: "terms___ru"
  }, {
    path: "/ru/video-obzori",
    component: _3aadcbfe,
    pathToRegexpOptions: {"strict":true},
    name: "video-obzori___ru"
  }, {
    path: "/uk/404",
    component: _442ba404,
    pathToRegexpOptions: {"strict":true},
    name: "404___uk"
  }, {
    path: "/uk/about",
    component: _54c682d4,
    pathToRegexpOptions: {"strict":true},
    name: "about___uk"
  }, {
    path: "/uk/account",
    component: _249409b6,
    pathToRegexpOptions: {"strict":true},
    name: "account___uk"
  }, {
    path: "/uk/articles",
    component: _3cd28bac,
    pathToRegexpOptions: {"strict":true},
    name: "articles___uk"
  }, {
    path: "/uk/auth",
    component: _5775985c,
    pathToRegexpOptions: {"strict":true},
    name: "auth___uk"
  }, {
    path: "/uk/brands",
    component: _0ea44379,
    pathToRegexpOptions: {"strict":true},
    name: "brands___uk"
  }, {
    path: "/uk/cabinet",
    component: _da3c2fbe,
    pathToRegexpOptions: {"strict":true},
    name: "cabinet___uk"
  }, {
    path: "/uk/career",
    component: _1a0ee628,
    pathToRegexpOptions: {"strict":true},
    name: "career___uk"
  }, {
    path: "/uk/cart",
    component: _2fd03c4d,
    pathToRegexpOptions: {"strict":true},
    name: "cart___uk"
  }, {
    path: "/uk/catalog",
    component: _94a32ebc,
    pathToRegexpOptions: {"strict":true},
    name: "catalog___uk"
  }, {
    path: "/uk/compare",
    component: _44763c2b,
    pathToRegexpOptions: {"strict":true},
    name: "compare___uk"
  }, {
    path: "/uk/confirmation",
    component: _ef5bbc42,
    pathToRegexpOptions: {"strict":true},
    name: "confirmation___uk"
  }, {
    path: "/uk/contacts",
    component: _58d124c0,
    pathToRegexpOptions: {"strict":true},
    name: "contacts___uk"
  }, {
    path: "/uk/credit",
    component: _7e345423,
    pathToRegexpOptions: {"strict":true},
    name: "credit___uk"
  }, {
    path: "/uk/dayoffer",
    component: _c632ad2c,
    pathToRegexpOptions: {"strict":true},
    name: "dayoffer___uk"
  }, {
    path: "/uk/delivery",
    component: _6ee2531e,
    pathToRegexpOptions: {"strict":true},
    name: "delivery___uk"
  }, {
    path: "/uk/discount",
    component: _66fe3deb,
    pathToRegexpOptions: {"strict":true},
    name: "discount___uk"
  }, {
    path: "/uk/faq",
    component: _4fb37b42,
    pathToRegexpOptions: {"strict":true},
    name: "faq___uk"
  }, {
    path: "/uk/favorites",
    component: _50194d1d,
    pathToRegexpOptions: {"strict":true},
    name: "favorites___uk"
  }, {
    path: "/uk/feedbacks",
    component: _102af4d4,
    pathToRegexpOptions: {"strict":true},
    name: "feedbacks___uk"
  }, {
    path: "/uk/insurance",
    component: _0bd6dfc0,
    pathToRegexpOptions: {"strict":true},
    name: "insurance___uk"
  }, {
    path: "/uk/order",
    component: _48971d94,
    pathToRegexpOptions: {"strict":true},
    name: "order___uk"
  }, {
    path: "/uk/partners",
    component: _50eec055,
    pathToRegexpOptions: {"strict":true},
    name: "partners___uk"
  }, {
    path: "/uk/product",
    component: _433341f8,
    pathToRegexpOptions: {"strict":true},
    name: "product___uk"
  }, {
    path: "/uk/product_list",
    component: _210f3f9b,
    pathToRegexpOptions: {"strict":true},
    name: "product_list___uk"
  }, {
    path: "/uk/products-feed",
    component: _5b6e482d,
    pathToRegexpOptions: {"strict":true},
    name: "products-feed___uk"
  }, {
    path: "/uk/questions",
    component: _46f6b913,
    pathToRegexpOptions: {"strict":true},
    name: "questions___uk"
  }, {
    path: "/uk/regulamente",
    component: _3cd63992,
    pathToRegexpOptions: {"strict":true},
    name: "regulamente___uk"
  }, {
    path: "/uk/review",
    component: _2ed25902,
    pathToRegexpOptions: {"strict":true},
    name: "review___uk"
  }, {
    path: "/uk/search",
    component: _757e1f52,
    pathToRegexpOptions: {"strict":true},
    name: "search___uk"
  }, {
    path: "/uk/service",
    component: _2bcd440a,
    pathToRegexpOptions: {"strict":true},
    name: "service___uk"
  }, {
    path: "/uk/special-offers",
    component: _730dca18,
    pathToRegexpOptions: {"strict":true},
    name: "special-offers___uk"
  }, {
    path: "/uk/terms",
    component: _4c6bc966,
    pathToRegexpOptions: {"strict":true},
    name: "terms___uk"
  }, {
    path: "/uk/video-obzori",
    component: _3aadcbfe,
    pathToRegexpOptions: {"strict":true},
    name: "video-obzori___uk"
  }, {
    path: "/en/account/history",
    component: _53947178,
    pathToRegexpOptions: {"strict":true},
    name: "account-history___en"
  }, {
    path: "/en/cabinet/activate",
    component: _f1f5be18,
    pathToRegexpOptions: {"strict":true},
    name: "cabinet-activate___en"
  }, {
    path: "/en/cabinet/orders",
    component: _64d7e7b4,
    pathToRegexpOptions: {"strict":true},
    name: "cabinet-orders___en"
  }, {
    path: "/en/cabinet/profile-security",
    component: _6f513165,
    pathToRegexpOptions: {"strict":true},
    name: "cabinet-profile-security___en"
  }, {
    path: "/en/cabinet/reset",
    component: _3ba4561e,
    pathToRegexpOptions: {"strict":true},
    name: "cabinet-reset___en"
  }, {
    path: "/en/cart/casaCart",
    component: _869ecbf8,
    pathToRegexpOptions: {"strict":true},
    name: "cart-casaCart___en"
  }, {
    path: "/en/cart/farmacieCart",
    component: _97b5ff68,
    pathToRegexpOptions: {"strict":true},
    name: "cart-farmacieCart___en"
  }, {
    path: "/en/cart/success",
    component: _1ffa663e,
    pathToRegexpOptions: {"strict":true},
    name: "cart-success___en"
  }, {
    path: "/en/faq/types",
    component: _b3141f6e,
    pathToRegexpOptions: {"strict":true},
    name: "faq-types___en"
  }, {
    path: "/en/video-obzori/view",
    component: _30e032ae,
    pathToRegexpOptions: {"strict":true},
    name: "video-obzori-view___en"
  }, {
    path: "/ro/account/history",
    component: _53947178,
    pathToRegexpOptions: {"strict":true},
    name: "account-history___ro"
  }, {
    path: "/ro/cabinet/activate",
    component: _f1f5be18,
    pathToRegexpOptions: {"strict":true},
    name: "cabinet-activate___ro"
  }, {
    path: "/ro/cabinet/orders",
    component: _64d7e7b4,
    pathToRegexpOptions: {"strict":true},
    name: "cabinet-orders___ro"
  }, {
    path: "/ro/cabinet/profile-security",
    component: _6f513165,
    pathToRegexpOptions: {"strict":true},
    name: "cabinet-profile-security___ro"
  }, {
    path: "/ro/cabinet/reset",
    component: _3ba4561e,
    pathToRegexpOptions: {"strict":true},
    name: "cabinet-reset___ro"
  }, {
    path: "/ro/cart/casaCart",
    component: _869ecbf8,
    pathToRegexpOptions: {"strict":true},
    name: "cart-casaCart___ro"
  }, {
    path: "/ro/cart/farmacieCart",
    component: _97b5ff68,
    pathToRegexpOptions: {"strict":true},
    name: "cart-farmacieCart___ro"
  }, {
    path: "/ro/cart/success",
    component: _1ffa663e,
    pathToRegexpOptions: {"strict":true},
    name: "cart-success___ro"
  }, {
    path: "/ro/faq/types",
    component: _b3141f6e,
    pathToRegexpOptions: {"strict":true},
    name: "faq-types___ro"
  }, {
    path: "/ro/video-obzori/view",
    component: _30e032ae,
    pathToRegexpOptions: {"strict":true},
    name: "video-obzori-view___ro"
  }, {
    path: "/ru/account/history",
    component: _53947178,
    pathToRegexpOptions: {"strict":true},
    name: "account-history___ru"
  }, {
    path: "/ru/cabinet/activate",
    component: _f1f5be18,
    pathToRegexpOptions: {"strict":true},
    name: "cabinet-activate___ru"
  }, {
    path: "/ru/cabinet/orders",
    component: _64d7e7b4,
    pathToRegexpOptions: {"strict":true},
    name: "cabinet-orders___ru"
  }, {
    path: "/ru/cabinet/profile-security",
    component: _6f513165,
    pathToRegexpOptions: {"strict":true},
    name: "cabinet-profile-security___ru"
  }, {
    path: "/ru/cabinet/reset",
    component: _3ba4561e,
    pathToRegexpOptions: {"strict":true},
    name: "cabinet-reset___ru"
  }, {
    path: "/ru/cart/casaCart",
    component: _869ecbf8,
    pathToRegexpOptions: {"strict":true},
    name: "cart-casaCart___ru"
  }, {
    path: "/ru/cart/farmacieCart",
    component: _97b5ff68,
    pathToRegexpOptions: {"strict":true},
    name: "cart-farmacieCart___ru"
  }, {
    path: "/ru/cart/success",
    component: _1ffa663e,
    pathToRegexpOptions: {"strict":true},
    name: "cart-success___ru"
  }, {
    path: "/ru/faq/types",
    component: _b3141f6e,
    pathToRegexpOptions: {"strict":true},
    name: "faq-types___ru"
  }, {
    path: "/ru/video-obzori/view",
    component: _30e032ae,
    pathToRegexpOptions: {"strict":true},
    name: "video-obzori-view___ru"
  }, {
    path: "/uk/account/history",
    component: _53947178,
    pathToRegexpOptions: {"strict":true},
    name: "account-history___uk"
  }, {
    path: "/uk/cabinet/activate",
    component: _f1f5be18,
    pathToRegexpOptions: {"strict":true},
    name: "cabinet-activate___uk"
  }, {
    path: "/uk/cabinet/orders",
    component: _64d7e7b4,
    pathToRegexpOptions: {"strict":true},
    name: "cabinet-orders___uk"
  }, {
    path: "/uk/cabinet/profile-security",
    component: _6f513165,
    pathToRegexpOptions: {"strict":true},
    name: "cabinet-profile-security___uk"
  }, {
    path: "/uk/cabinet/reset",
    component: _3ba4561e,
    pathToRegexpOptions: {"strict":true},
    name: "cabinet-reset___uk"
  }, {
    path: "/uk/cart/casaCart",
    component: _869ecbf8,
    pathToRegexpOptions: {"strict":true},
    name: "cart-casaCart___uk"
  }, {
    path: "/uk/cart/farmacieCart",
    component: _97b5ff68,
    pathToRegexpOptions: {"strict":true},
    name: "cart-farmacieCart___uk"
  }, {
    path: "/uk/cart/success",
    component: _1ffa663e,
    pathToRegexpOptions: {"strict":true},
    name: "cart-success___uk"
  }, {
    path: "/uk/faq/types",
    component: _b3141f6e,
    pathToRegexpOptions: {"strict":true},
    name: "faq-types___uk"
  }, {
    path: "/uk/video-obzori/view",
    component: _30e032ae,
    pathToRegexpOptions: {"strict":true},
    name: "video-obzori-view___uk"
  }, {
    path: "/en/about/components/ContentImageBlock",
    component: _18f4aa61,
    pathToRegexpOptions: {"strict":true},
    name: "about-components-ContentImageBlock___en"
  }, {
    path: "/en/about/components/LogoTypes",
    component: _2bc579e4,
    pathToRegexpOptions: {"strict":true},
    name: "about-components-LogoTypes___en"
  }, {
    path: "/en/cart/casaCart/types",
    component: _51c0dff8,
    pathToRegexpOptions: {"strict":true},
    name: "cart-casaCart-types___en"
  }, {
    path: "/en/contacts/components/Form",
    component: _34de3d24,
    pathToRegexpOptions: {"strict":true},
    name: "contacts-components-Form___en"
  }, {
    path: "/en/faq/components/AccordionsBlock",
    component: _b375c662,
    pathToRegexpOptions: {"strict":true},
    name: "faq-components-AccordionsBlock___en"
  }, {
    path: "/ro/about/components/ContentImageBlock",
    component: _18f4aa61,
    pathToRegexpOptions: {"strict":true},
    name: "about-components-ContentImageBlock___ro"
  }, {
    path: "/ro/about/components/LogoTypes",
    component: _2bc579e4,
    pathToRegexpOptions: {"strict":true},
    name: "about-components-LogoTypes___ro"
  }, {
    path: "/ro/cart/casaCart/types",
    component: _51c0dff8,
    pathToRegexpOptions: {"strict":true},
    name: "cart-casaCart-types___ro"
  }, {
    path: "/ro/contacts/components/Form",
    component: _34de3d24,
    pathToRegexpOptions: {"strict":true},
    name: "contacts-components-Form___ro"
  }, {
    path: "/ro/faq/components/AccordionsBlock",
    component: _b375c662,
    pathToRegexpOptions: {"strict":true},
    name: "faq-components-AccordionsBlock___ro"
  }, {
    path: "/ru/about/components/ContentImageBlock",
    component: _18f4aa61,
    pathToRegexpOptions: {"strict":true},
    name: "about-components-ContentImageBlock___ru"
  }, {
    path: "/ru/about/components/LogoTypes",
    component: _2bc579e4,
    pathToRegexpOptions: {"strict":true},
    name: "about-components-LogoTypes___ru"
  }, {
    path: "/ru/cart/casaCart/types",
    component: _51c0dff8,
    pathToRegexpOptions: {"strict":true},
    name: "cart-casaCart-types___ru"
  }, {
    path: "/ru/contacts/components/Form",
    component: _34de3d24,
    pathToRegexpOptions: {"strict":true},
    name: "contacts-components-Form___ru"
  }, {
    path: "/ru/faq/components/AccordionsBlock",
    component: _b375c662,
    pathToRegexpOptions: {"strict":true},
    name: "faq-components-AccordionsBlock___ru"
  }, {
    path: "/uk/about/components/ContentImageBlock",
    component: _18f4aa61,
    pathToRegexpOptions: {"strict":true},
    name: "about-components-ContentImageBlock___uk"
  }, {
    path: "/uk/about/components/LogoTypes",
    component: _2bc579e4,
    pathToRegexpOptions: {"strict":true},
    name: "about-components-LogoTypes___uk"
  }, {
    path: "/uk/cart/casaCart/types",
    component: _51c0dff8,
    pathToRegexpOptions: {"strict":true},
    name: "cart-casaCart-types___uk"
  }, {
    path: "/uk/contacts/components/Form",
    component: _34de3d24,
    pathToRegexpOptions: {"strict":true},
    name: "contacts-components-Form___uk"
  }, {
    path: "/uk/faq/components/AccordionsBlock",
    component: _b375c662,
    pathToRegexpOptions: {"strict":true},
    name: "faq-components-AccordionsBlock___uk"
  }, {
    path: "/en/about/components/ContentImageBlock/types",
    component: _4bccfff2,
    pathToRegexpOptions: {"strict":true},
    name: "about-components-ContentImageBlock-types___en"
  }, {
    path: "/en/cart/casaCart/components/CartProducts",
    component: _a18c10dc,
    pathToRegexpOptions: {"strict":true},
    name: "cart-casaCart-components-CartProducts___en"
  }, {
    path: "/en/cart/casaCart/components/Credits",
    component: _01e42e82,
    pathToRegexpOptions: {"strict":true},
    name: "cart-casaCart-components-Credits___en"
  }, {
    path: "/en/cart/casaCart/components/Form",
    component: _89f5629c,
    pathToRegexpOptions: {"strict":true},
    name: "cart-casaCart-components-Form___en"
  }, {
    path: "/ro/about/components/ContentImageBlock/types",
    component: _4bccfff2,
    pathToRegexpOptions: {"strict":true},
    name: "about-components-ContentImageBlock-types___ro"
  }, {
    path: "/ro/cart/casaCart/components/CartProducts",
    component: _a18c10dc,
    pathToRegexpOptions: {"strict":true},
    name: "cart-casaCart-components-CartProducts___ro"
  }, {
    path: "/ro/cart/casaCart/components/Credits",
    component: _01e42e82,
    pathToRegexpOptions: {"strict":true},
    name: "cart-casaCart-components-Credits___ro"
  }, {
    path: "/ro/cart/casaCart/components/Form",
    component: _89f5629c,
    pathToRegexpOptions: {"strict":true},
    name: "cart-casaCart-components-Form___ro"
  }, {
    path: "/ru/about/components/ContentImageBlock/types",
    component: _4bccfff2,
    pathToRegexpOptions: {"strict":true},
    name: "about-components-ContentImageBlock-types___ru"
  }, {
    path: "/ru/cart/casaCart/components/CartProducts",
    component: _a18c10dc,
    pathToRegexpOptions: {"strict":true},
    name: "cart-casaCart-components-CartProducts___ru"
  }, {
    path: "/ru/cart/casaCart/components/Credits",
    component: _01e42e82,
    pathToRegexpOptions: {"strict":true},
    name: "cart-casaCart-components-Credits___ru"
  }, {
    path: "/ru/cart/casaCart/components/Form",
    component: _89f5629c,
    pathToRegexpOptions: {"strict":true},
    name: "cart-casaCart-components-Form___ru"
  }, {
    path: "/uk/about/components/ContentImageBlock/types",
    component: _4bccfff2,
    pathToRegexpOptions: {"strict":true},
    name: "about-components-ContentImageBlock-types___uk"
  }, {
    path: "/uk/cart/casaCart/components/CartProducts",
    component: _a18c10dc,
    pathToRegexpOptions: {"strict":true},
    name: "cart-casaCart-components-CartProducts___uk"
  }, {
    path: "/uk/cart/casaCart/components/Credits",
    component: _01e42e82,
    pathToRegexpOptions: {"strict":true},
    name: "cart-casaCart-components-Credits___uk"
  }, {
    path: "/uk/cart/casaCart/components/Form",
    component: _89f5629c,
    pathToRegexpOptions: {"strict":true},
    name: "cart-casaCart-components-Form___uk"
  }, {
    path: "/en/cart/casaCart/components/CartProducts/PlankCard",
    component: _0fd7ec35,
    pathToRegexpOptions: {"strict":true},
    name: "cart-casaCart-components-CartProducts-PlankCard___en"
  }, {
    path: "/en/cart/casaCart/components/Form/MyActionBtn",
    component: _b323e286,
    pathToRegexpOptions: {"strict":true},
    name: "cart-casaCart-components-Form-MyActionBtn___en"
  }, {
    path: "/en/cart/casaCart/components/Form/MyActionTabBtn",
    component: _01b29a48,
    pathToRegexpOptions: {"strict":true},
    name: "cart-casaCart-components-Form-MyActionTabBtn___en"
  }, {
    path: "/en/cart/casaCart/components/Form/MyCheckboxBtn",
    component: _42ff5160,
    pathToRegexpOptions: {"strict":true},
    name: "cart-casaCart-components-Form-MyCheckboxBtn___en"
  }, {
    path: "/en/cart/casaCart/components/Form/MyInput",
    component: _35e04b41,
    pathToRegexpOptions: {"strict":true},
    name: "cart-casaCart-components-Form-MyInput___en"
  }, {
    path: "/en/cart/casaCart/components/Form/MySelect",
    component: _4871288a,
    pathToRegexpOptions: {"strict":true},
    name: "cart-casaCart-components-Form-MySelect___en"
  }, {
    path: "/en/cart/casaCart/components/Form/MySwitchToggler",
    component: _43dfa541,
    pathToRegexpOptions: {"strict":true},
    name: "cart-casaCart-components-Form-MySwitchToggler___en"
  }, {
    path: "/en/cart/casaCart/components/Form/MyTextarea",
    component: _b70ec10e,
    pathToRegexpOptions: {"strict":true},
    name: "cart-casaCart-components-Form-MyTextarea___en"
  }, {
    path: "/ro/cart/casaCart/components/CartProducts/PlankCard",
    component: _0fd7ec35,
    pathToRegexpOptions: {"strict":true},
    name: "cart-casaCart-components-CartProducts-PlankCard___ro"
  }, {
    path: "/ro/cart/casaCart/components/Form/MyActionBtn",
    component: _b323e286,
    pathToRegexpOptions: {"strict":true},
    name: "cart-casaCart-components-Form-MyActionBtn___ro"
  }, {
    path: "/ro/cart/casaCart/components/Form/MyActionTabBtn",
    component: _01b29a48,
    pathToRegexpOptions: {"strict":true},
    name: "cart-casaCart-components-Form-MyActionTabBtn___ro"
  }, {
    path: "/ro/cart/casaCart/components/Form/MyCheckboxBtn",
    component: _42ff5160,
    pathToRegexpOptions: {"strict":true},
    name: "cart-casaCart-components-Form-MyCheckboxBtn___ro"
  }, {
    path: "/ro/cart/casaCart/components/Form/MyInput",
    component: _35e04b41,
    pathToRegexpOptions: {"strict":true},
    name: "cart-casaCart-components-Form-MyInput___ro"
  }, {
    path: "/ro/cart/casaCart/components/Form/MySelect",
    component: _4871288a,
    pathToRegexpOptions: {"strict":true},
    name: "cart-casaCart-components-Form-MySelect___ro"
  }, {
    path: "/ro/cart/casaCart/components/Form/MySwitchToggler",
    component: _43dfa541,
    pathToRegexpOptions: {"strict":true},
    name: "cart-casaCart-components-Form-MySwitchToggler___ro"
  }, {
    path: "/ro/cart/casaCart/components/Form/MyTextarea",
    component: _b70ec10e,
    pathToRegexpOptions: {"strict":true},
    name: "cart-casaCart-components-Form-MyTextarea___ro"
  }, {
    path: "/ru/cart/casaCart/components/CartProducts/PlankCard",
    component: _0fd7ec35,
    pathToRegexpOptions: {"strict":true},
    name: "cart-casaCart-components-CartProducts-PlankCard___ru"
  }, {
    path: "/ru/cart/casaCart/components/Form/MyActionBtn",
    component: _b323e286,
    pathToRegexpOptions: {"strict":true},
    name: "cart-casaCart-components-Form-MyActionBtn___ru"
  }, {
    path: "/ru/cart/casaCart/components/Form/MyActionTabBtn",
    component: _01b29a48,
    pathToRegexpOptions: {"strict":true},
    name: "cart-casaCart-components-Form-MyActionTabBtn___ru"
  }, {
    path: "/ru/cart/casaCart/components/Form/MyCheckboxBtn",
    component: _42ff5160,
    pathToRegexpOptions: {"strict":true},
    name: "cart-casaCart-components-Form-MyCheckboxBtn___ru"
  }, {
    path: "/ru/cart/casaCart/components/Form/MyInput",
    component: _35e04b41,
    pathToRegexpOptions: {"strict":true},
    name: "cart-casaCart-components-Form-MyInput___ru"
  }, {
    path: "/ru/cart/casaCart/components/Form/MySelect",
    component: _4871288a,
    pathToRegexpOptions: {"strict":true},
    name: "cart-casaCart-components-Form-MySelect___ru"
  }, {
    path: "/ru/cart/casaCart/components/Form/MySwitchToggler",
    component: _43dfa541,
    pathToRegexpOptions: {"strict":true},
    name: "cart-casaCart-components-Form-MySwitchToggler___ru"
  }, {
    path: "/ru/cart/casaCart/components/Form/MyTextarea",
    component: _b70ec10e,
    pathToRegexpOptions: {"strict":true},
    name: "cart-casaCart-components-Form-MyTextarea___ru"
  }, {
    path: "/uk/cart/casaCart/components/CartProducts/PlankCard",
    component: _0fd7ec35,
    pathToRegexpOptions: {"strict":true},
    name: "cart-casaCart-components-CartProducts-PlankCard___uk"
  }, {
    path: "/uk/cart/casaCart/components/Form/MyActionBtn",
    component: _b323e286,
    pathToRegexpOptions: {"strict":true},
    name: "cart-casaCart-components-Form-MyActionBtn___uk"
  }, {
    path: "/uk/cart/casaCart/components/Form/MyActionTabBtn",
    component: _01b29a48,
    pathToRegexpOptions: {"strict":true},
    name: "cart-casaCart-components-Form-MyActionTabBtn___uk"
  }, {
    path: "/uk/cart/casaCart/components/Form/MyCheckboxBtn",
    component: _42ff5160,
    pathToRegexpOptions: {"strict":true},
    name: "cart-casaCart-components-Form-MyCheckboxBtn___uk"
  }, {
    path: "/uk/cart/casaCart/components/Form/MyInput",
    component: _35e04b41,
    pathToRegexpOptions: {"strict":true},
    name: "cart-casaCart-components-Form-MyInput___uk"
  }, {
    path: "/uk/cart/casaCart/components/Form/MySelect",
    component: _4871288a,
    pathToRegexpOptions: {"strict":true},
    name: "cart-casaCart-components-Form-MySelect___uk"
  }, {
    path: "/uk/cart/casaCart/components/Form/MySwitchToggler",
    component: _43dfa541,
    pathToRegexpOptions: {"strict":true},
    name: "cart-casaCart-components-Form-MySwitchToggler___uk"
  }, {
    path: "/uk/cart/casaCart/components/Form/MyTextarea",
    component: _b70ec10e,
    pathToRegexpOptions: {"strict":true},
    name: "cart-casaCart-components-Form-MyTextarea___uk"
  }, {
    path: "/en/cart/casaCart/components/Form/MyActionBtn/types",
    component: _07f4202b,
    pathToRegexpOptions: {"strict":true},
    name: "cart-casaCart-components-Form-MyActionBtn-types___en"
  }, {
    path: "/ro/cart/casaCart/components/Form/MyActionBtn/types",
    component: _07f4202b,
    pathToRegexpOptions: {"strict":true},
    name: "cart-casaCart-components-Form-MyActionBtn-types___ro"
  }, {
    path: "/ru/cart/casaCart/components/Form/MyActionBtn/types",
    component: _07f4202b,
    pathToRegexpOptions: {"strict":true},
    name: "cart-casaCart-components-Form-MyActionBtn-types___ru"
  }, {
    path: "/uk/cart/casaCart/components/Form/MyActionBtn/types",
    component: _07f4202b,
    pathToRegexpOptions: {"strict":true},
    name: "cart-casaCart-components-Form-MyActionBtn-types___uk"
  }, {
    path: "/en/articles/:url",
    component: _491e3f88,
    pathToRegexpOptions: {"strict":true},
    name: "articles-url___en"
  }, {
    path: "/en/brands/:slug",
    component: _0ceda231,
    pathToRegexpOptions: {"strict":true},
    name: "brands-slug___en"
  }, {
    path: "/en/l/:slug?",
    component: _55ae1326,
    pathToRegexpOptions: {"strict":true},
    name: "l-slug___en"
  }, {
    path: "/en/product/:product",
    component: _c9b6480c,
    pathToRegexpOptions: {"strict":true},
    name: "product-product___en"
  }, {
    path: "/en/promo/:slug?",
    component: _0f994850,
    pathToRegexpOptions: {"strict":true},
    name: "promo-slug___en"
  }, {
    path: "/en/special-offers/:url?",
    component: _6ca30c4c,
    pathToRegexpOptions: {"strict":true},
    name: "special-offers-url___en"
  }, {
    path: "/ro/articles/:url",
    component: _491e3f88,
    pathToRegexpOptions: {"strict":true},
    name: "articles-url___ro"
  }, {
    path: "/ro/brands/:slug",
    component: _0ceda231,
    pathToRegexpOptions: {"strict":true},
    name: "brands-slug___ro"
  }, {
    path: "/ro/l/:slug?",
    component: _55ae1326,
    pathToRegexpOptions: {"strict":true},
    name: "l-slug___ro"
  }, {
    path: "/ro/product/:product",
    component: _c9b6480c,
    pathToRegexpOptions: {"strict":true},
    name: "product-product___ro"
  }, {
    path: "/ro/promo/:slug?",
    component: _0f994850,
    pathToRegexpOptions: {"strict":true},
    name: "promo-slug___ro"
  }, {
    path: "/ro/special-offers/:url?",
    component: _6ca30c4c,
    pathToRegexpOptions: {"strict":true},
    name: "special-offers-url___ro"
  }, {
    path: "/ru/articles/:url",
    component: _491e3f88,
    pathToRegexpOptions: {"strict":true},
    name: "articles-url___ru"
  }, {
    path: "/ru/brands/:slug",
    component: _0ceda231,
    pathToRegexpOptions: {"strict":true},
    name: "brands-slug___ru"
  }, {
    path: "/ru/l/:slug?",
    component: _55ae1326,
    pathToRegexpOptions: {"strict":true},
    name: "l-slug___ru"
  }, {
    path: "/ru/product/:product",
    component: _c9b6480c,
    pathToRegexpOptions: {"strict":true},
    name: "product-product___ru"
  }, {
    path: "/ru/promo/:slug?",
    component: _0f994850,
    pathToRegexpOptions: {"strict":true},
    name: "promo-slug___ru"
  }, {
    path: "/ru/special-offers/:url?",
    component: _6ca30c4c,
    pathToRegexpOptions: {"strict":true},
    name: "special-offers-url___ru"
  }, {
    path: "/uk/articles/:url",
    component: _491e3f88,
    pathToRegexpOptions: {"strict":true},
    name: "articles-url___uk"
  }, {
    path: "/uk/brands/:slug",
    component: _0ceda231,
    pathToRegexpOptions: {"strict":true},
    name: "brands-slug___uk"
  }, {
    path: "/uk/l/:slug?",
    component: _55ae1326,
    pathToRegexpOptions: {"strict":true},
    name: "l-slug___uk"
  }, {
    path: "/uk/product/:product",
    component: _c9b6480c,
    pathToRegexpOptions: {"strict":true},
    name: "product-product___uk"
  }, {
    path: "/uk/promo/:slug?",
    component: _0f994850,
    pathToRegexpOptions: {"strict":true},
    name: "promo-slug___uk"
  }, {
    path: "/uk/special-offers/:url?",
    component: _6ca30c4c,
    pathToRegexpOptions: {"strict":true},
    name: "special-offers-url___uk"
  }, {
    path: "/en/*",
    component: _0d852d25,
    pathToRegexpOptions: {"strict":true},
    name: "all___en"
  }, {
    path: "/uk/*",
    component: _0d852d25,
    pathToRegexpOptions: {"strict":true},
    name: "all___uk"
  }, {
    path: "/ru/*",
    component: _0d852d25,
    pathToRegexpOptions: {"strict":true},
    name: "all___ru"
  }, {
    path: "/ro/*",
    component: _0d852d25,
    pathToRegexpOptions: {"strict":true},
    name: "all___ro"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
